import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe, DecimalPipe } from '@angular/common';

@Pipe({
  name: 'negativeToBracket'
})
export class NegativeToBracketPipe implements PipeTransform {

  constructor(private readonly currencyPipe: CurrencyPipe, private readonly decimalPipe: DecimalPipe) { }

  transform(value: number | string | undefined, showCurrency: boolean = false): string {
    if (value === undefined || value === null) {
      return '';
    }
    if(typeof(value) === 'string' && value === 'N/A'){
      return value;
    }
    let numberValue: number = +value;
    // Format to two decimal places
    //const formattedValue = value.toFixed(2);    
    if (showCurrency) {
      // Show currency and wrap the negative sign inside brackets
      const formattedCurrency = this.currencyPipe.transform(numberValue, 'USD', 'symbol', '1.2-2');
      if (numberValue < 0) {
        return `(${ formattedCurrency?.slice(1) })`; // Remove the negative sign and wrap in bracket
      }      
      return formattedCurrency ?? '0'; // For positive values, show currency normally 
    } else {
      // Show the value inside brackets if it's negative, without currency
      const formattedValue = this.decimalPipe.transform(numberValue, '1.2-2');
      if (numberValue < 0) {
        return `(${ formattedValue?.slice(1) })`;
      }
      return formattedValue ?? '0'; // Positive values show as normal number
    }
  }
}
